import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { withFormUtils } from '../../../hoc/withFormUtils';
import SettingsTabulator from '../../../components/layouts/SettingsTabulator';
import { formUtilsHocPropTypes } from '../../../propTypes';
import AdditionalHtml from './Sections/AdditionalHtml';

const propTypes =
{
    utils: formUtilsHocPropTypes,
    getPromotionBar: PropTypes.func,
    updatePromotionBar: PropTypes.func,
    forceRefetch: PropTypes.bool
};

const HeaderSettings = () =>
{
    const intl = useIntl();
    const translations = intl.messages.menuSettings.header;
    const refreshTabComponent = tabulatorId =>
    {
        switch (tabulatorId)
        {
            case 'headerSettings-AdditionalHtml':
                return <AdditionalHtml />;
            default:
                return null;
        }
    };
    return (
        <SettingsTabulator
                title={{ label: translations.title }}
                tabulatorHeader={{
                    label: 'translations.tabSelectorTitle',
                    iconClassName: 'fa fa-align-justify'
                }}
                refreshTabComponent={refreshTabComponent}
                tabs={[
                    {
                        id: `headerSettings-AdditionalHtml`,
                        header:
                        {
                            label: translations.sections.additionalHtml.title,
                            iconClassName: 'nav-icon cil-code'
                        }
                    }
                ]}
        />
    );
};

HeaderSettings.propTypes = propTypes;

export default withFormUtils(HeaderSettings);